import Select, { StylesConfig, Props } from 'react-select';

const colourStyles: StylesConfig = {
  control: styles => ({
    ...styles,
    borderRadius: 8,
    borderColor: '#D8DAE5',
    borderWidth: 1,

    ':hover': {
      borderColor: '#D8DAE5',
    },
    cursor: 'pointer',
    minHeight: 42,
    boxShadow: 'none',
  }),
  container: styles => ({
    ...styles,
  }),
  option: styles => ({
    ...styles,
    color: '#161A30',
    cursor: 'pointer',
    backgroundColor: '#fff',
    fontSize: 14,
    padding: '12px 16px',
    fontWeight: 400,

    ':active': {
      ...styles[':active'],
      backgroundColor: '#fff',
    },
  }),
  indicatorSeparator: () => ({ backgroundColor: '#fff' }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : '',
    color: '#8F95B2',
    padding: '0',
    paddingRight: '0px',
    marginRight: 10,
    ':disabled': {
      ...styles[':active'],
      backgroundColor: '#fff',
    },
  }),
  menu: styles => ({
    ...styles,
    borderRadius: 8,
    border: '1px solid #D8DAE5',
    marginTop: 4,
    boxShadow: 'none',
  }),
  valueContainer: styles => ({
    ...styles,
    padding: '0 12px',
    fontWeight: 400,
    '& input': {
      fontSize: '12px !important',
    },
  }),
  input: styles => ({
    ...styles,
    margin: 0,
    padding: 0,
  }),
  placeholder: styles => ({
    ...styles,
    color: '#8F95B2',
    fontSize: 14,
    fontWeight: 400,
  }),
  singleValue: styles => ({
    ...styles,
    fontSize: '14px !important',
    fontWeight: 400,
  }),
};

const CustomPicker = (props: Props) => {
  return <Select styles={colourStyles} {...props} />;
};

export { CustomPicker };
